// src/stockx/base/SecurityIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var SecurityIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  colorized && /* @__PURE__ */ jsx("path", { d: "M38.4 24.3H10.8V42.3H38.4V24.3Z", fill: "#006340" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M39.8 43.4H10V23.2H39.8V43.4ZM12.2 41.2H37.5V25.4H12.2V41.2Z",
      fill: colorized ? "#D4D1C7" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M34.3 24.3H32.1V16.4C32.1 12.4 28.9 9.2 24.9 9.2C20.9 9.2 17.7 12.4 17.7 16.4V24.3H15.5V16.4C15.5 11.2 19.7 7 24.9 7C30.1 7 34.3 11.2 34.3 16.4V24.3Z",
      fill: colorized ? "#D4D1C7" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M27.5 31.4C27.5 30 26.3 28.8 24.9 28.8C23.5 28.8 22.3 30 22.3 31.4C22.3 32.4 22.9 33.3 23.7 33.7V37.8H25.9V33.7C26.9 33.3 27.5 32.4 27.5 31.4Z",
      fill: colorized ? "#D4D1C7" : "currentColor"
    }
  )
] });
var SecurityIcon_default = SecurityIcon;

export {
  SecurityIcon_default
};
